export const poundsToPence = (value) => {
  value = parseFloat(value);
  if (!isNaN(value)) {
    return (value * 100).toFixed(0);
  }

  return '';
};
